var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedBtns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(193 -553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3796",
    width: 40,
    height: 20,
    fill: "#6b7ef2",
    "data-name": "Rectangle 3796",
    rx: 10,
    transform: "translate(-193 553)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#fff",
    "data-name": "Ellipse 31",
    transform: "translate(-172 554)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBtns);
export default __webpack_public_path__ + "static/media/selected_btns.a34a455fc96235c446cceca47fc9bb7e.svg";
export { ForwardRef as ReactComponent };